import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card page--limited" }
const _hoisted_2 = { class: "p-p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_CustomerAppData = _resolveComponent("CustomerAppData")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      title: _ctx.isNew ? _ctx.$t('app_customer.detail.new') : _ctx.$t('app_customer.detail.edit'),
      backRoute: _ctx.backRoute,
      onOnDelete: _ctx.onDelete,
      deleteDisabled: _ctx.isNew
    }, {
      saveButton: _withCtx(() => [
        _withDirectives(_createVNode(_component_Button, {
          class: "p-mr-1",
          icon: "pi pi-save",
          onClick: _ctx.onSubmit
        }, null, 8, ["onClick"]), [
          [
            _directive_tooltip,
            _ctx.$t('common.save'),
            void 0,
            { bottom: true }
          ]
        ])
      ]),
      _: 1
    }, 8, ["title", "backRoute", "onOnDelete", "deleteDisabled"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CustomerAppData, {
        isLoading: !_ctx.customer || _ctx.isLoading,
        customerId: _ctx.customerId,
        customer: _ctx.customer,
        user: _ctx.customerUser,
        onFormSubmit: _ctx.onSubmit
      }, null, 8, ["isLoading", "customerId", "customer", "user", "onFormSubmit"])
    ])
  ]))
}